import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
import test from '@/pages/test'

Vue.use(Router)

export default new Router({
  mode:'history',
  routes: [
    // {
    //   path: '/HelloWorld',
    //   name: 'HelloWorld',
    //   component: HelloWorld
    // },
    {
      path: '/',
      name: 'test',
      component: test
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js